import {
  BlockType,
  EDITOR_MODE,
  useEditorStateSelector
} from "@pathwright/blocks-engine"
import { memo, useMemo } from "react"
import BlockLoading from "./BlockLoading"
import BlockWrap, { EditorBlockWrap } from "./BlockWrap"
import { getBlock } from "./utils"

interface BlockContainerProps {
  blockIndex?: number
  block: BlockType
  onChange: (dataUpdates: Record<string, any>) => void
}

const propsAreEqual = (
  prevProps: BlockContainerProps,
  nextProps: BlockContainerProps
) => {
  if (nextProps.block !== prevProps.block) return false
  if (nextProps.blockIndex !== prevProps.blockIndex) return false

  return true
}

const BlockContainer = memo((props: BlockContainerProps) => {
  const { blockIndex, block, onChange } = props
  const { type, style } = block
  const mode = useEditorStateSelector((state) => state.mode)

  const blockStyles = useMemo(() => block.style, [block.style])

  const Block = useMemo(() => getBlock(type, mode), [type, mode])

  if (!Block) return <BlockLoading />

  const wrapProps = {
    styledColor: style?.styleAttributes?.color,
    styledBackground: style?.styleAttributes?.backgroundColor,
    style: {
      ...(style?.styleAttributes || {}),
      transition: "all 0.5s"
    }
  }

  const blockElement = (
    <Block
      {...block}
      onChange={onChange}
      blockIndex={blockIndex}
      blockStyles={blockStyles}
    />
  )

  if (mode === EDITOR_MODE.EDIT) {
    return (
      <EditorBlockWrap {...wrapProps} index={blockIndex}>
        {blockElement}
      </EditorBlockWrap>
    )
  }

  return (
    <BlockWrap {...wrapProps} block={block}>
      {blockElement}
    </BlockWrap>
  )
}, propsAreEqual)

export default BlockContainer
